import React from 'react';
import { motion } from 'framer-motion';
import { ConsultationForm } from './ConsultationForm';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden bg-[var(--color-navy)] pb-16 pt-14 sm:pb-20 sm:pt-20" data-id="element-81" data-mp="2werr1sgdvouv">
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[var(--color-navy-light)]/40 blur-3xl" aria-hidden="true" data-id="element-82" data-mp="3b3fgri3jt4cw" />
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:items-start lg:gap-10 lg:px-8" data-id="element-83" data-mp="2ieqf9hykyx0m">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-84" data-mp="2di02p4lzijjy">
          <h1 className="font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-85" data-mp="2nd1rfzccljm0">
            Senior Living Website Design That Grows Occupancy
          </h1>
          <p className="mt-5 text-lg font-medium text-white/90 sm:text-xl" data-id="element-86" data-mp="2nvskxhqic4p">
            Custom WordPress websites for retirement communities, assisted living, and memory care.
          </p>
          <p className="mt-4 font-semibold text-[var(--color-lime)] text-[12px]" data-id="element-87" data-mp="21cq9m8yaj5ow">
            Award-winning designs, ADA-conscious build, and SEO baked in from day one.
          </p>
          <div className="relative mt-8 w-full overflow-hidden rounded-2xl border border-white/10 shadow-2xl" style={{
          paddingTop: '56.25%'
        }} data-id="element-88" data-mp="2adoib4joc1dt">
            <iframe src="https://player.vimeo.com/video/1033429728?badge=0&autopause=0&player_id=0&app_id=58479" title="Willow Ridge Senior Living Testimonial on Mannix Marketing's Digital Marketing Services" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" className="absolute left-0 top-0 h-full w-full" frameBorder={0} data-id="element-89" data-mp="1injqwlxhye33" />
          </div>
        </motion.div>
        <motion.div id="consultation-form" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} className="scroll-mt-24" data-id="element-90" data-mp="yy85hxb5rtki">
          <ConsultationForm formId="hero" heading="Get Your Free Website Consultation" data-id="element-91" data-mp="2c0rr7qlhjqhy" />
        </motion.div>
      </div>
    </section>;
}